import { Button } from '@hotjar/hotsauce';
import { InfoBox } from '@hotjar/webapp/components/InfoBox/InfoBox';
import { PaymentIcon as Icon, Name } from '@hotjar/webapp/components/PaymentIcons/PaymentIcons';
import { moment } from '@hotjar/webapp/lib/moment';
import { navigateTo } from '@hotjar/webapp/utils/routing';
import { SETTINGS } from '@hotjar/webapp/constants/routes';
import * as S from '../SubscriptionSummary.styles';
import { Heading } from '../SubscriptionCost/SubscriptionCost';
import type { SubscriptionNextInvoiceProps } from './SubscriptionNextInvoice';

type Props = Omit<SubscriptionNextInvoiceProps, 'account'>;

export const LegacySubscriptionNextInvoice = ({
  subscriptionInfo,
  hasPaidPlan,
}: Props): JSX.Element => {
  const onInvoice = () => navigateTo(SETTINGS.INVOICES.path);

  // TODO: renderInvoiceSectionContent and all checks for it is used for Zuora too,
  // consider sharing the logic if you touch this code
  const billingDate = subscriptionInfo && subscriptionInfo.nextBillingDate;
  const subscriptionAlerts = subscriptionInfo && subscriptionInfo.alerts;
  const isErrorInfo =
    hasPaidPlan && subscriptionAlerts.recurringPaymentFailed && !subscriptionAlerts.trialEndingSoon;

  const renderInvoiceSectionContent = () => {
    if (!hasPaidPlan || !billingDate) {
      return (
        <S.ContentSection>
          <Heading>N/A</Heading>
        </S.ContentSection>
      );
    }
    if (isErrorInfo) {
      return (
        <S.ContentSection>
          <S.ErrorInfoTitle>
            <Icon name={Name.warning} />
            {`Your ${moment.unix(billingDate).format('MMMM')} invoice is overdue`}
          </S.ErrorInfoTitle>
          <S.ErrorInfoContent>
            {`Please settle your payment before ${moment
              .unix(billingDate)
              .add(21, 'days')
              .format('Do MMMM YYYY')}
           to avoid interruptions in your subscription`}
          </S.ErrorInfoContent>
        </S.ContentSection>
      );
    }
    return (
      <S.ContentSection>
        <Heading>{moment.unix(billingDate).format('Do MMMM YYYY')}</Heading>
      </S.ContentSection>
    );
  };
  const footerCTA = isErrorInfo ? (
    <Button size="s" onClick={onInvoice}>
      View Invoice
    </Button>
  ) : (
    <S.SwitchLink onClick={onInvoice} variant="primary">
      {hasPaidPlan ? 'View invoices' : 'Invoices Page'}
    </S.SwitchLink>
  );

  return (
    <InfoBox
      title={<S.Header>Next Invoice </S.Header>}
      body={renderInvoiceSectionContent()}
      footer={footerCTA}
      isErrorInfo={isErrorInfo}
    />
  );
};

// eslint-disable-next-line import/no-default-export
export default LegacySubscriptionNextInvoice;
